/**
 * Destino del HTML generado por informes; permite redirigir al hub sin tocar la entidad del payload SQL.
 */
export function getReportInsertTarget(detail, legacyElementId) {  
  const id =
    detail && detail.reportPageRightId ? detail.reportPageRightId : legacyElementId;
  return document.getElementById(id);
}
